import { Text, VStack, Box } from '@chakra-ui/react';
import { Avatar, AvatarBg } from '@halo/ui-chat-react';

export function CallerInfo({
  avatar,
  name,
  isConnect,
  size = 'lg',
  hasVolume = false,
  showBg = false,
  playbackRate = 2,
}: {
  avatar?: string;
  name?: string;
  isConnect?: boolean;
  size?: any;
  hasVolume?: boolean;
  showBg?: boolean;
  playbackRate?: number;
}) {
  return (
    <VStack gap="2">
      <AvatarBg
        disabled={!showBg}
        play={hasVolume}
        playbackRate={playbackRate}
        autoPlay={playbackRate === 2 ? hasVolume : true}
        size={size}
      >
        <Avatar src={avatar} name={name} size={size} />
      </AvatarBg>
      {!isConnect && (
        <Box w="full" textAlign="center">
          <Text
            fontSize="medium"
            fontWeight="semibold"
            color="white"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {name}
          </Text>
        </Box>
      )}
    </VStack>
  );
}

export default memo(CallerInfo);
